import React from 'react'

import { trackKinds } from 'constants/twilio'

import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext'
import AudioLevelIndicator from '../../../AudioLevelIndicator/AudioLevelIndicator'

export default function LocalAudioLevelIndicator(props) {
    const { localTracks } = useVideoContext()
    const audioTrack = localTracks.find(
        track => track.kind === trackKinds.audio
    )

    console.count('LocalAudioLevelIndicator Component')

    return (
        <AudioLevelIndicator size={props.width || 30} audioTrack={audioTrack} />
    )
}
